import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { ICertifyingBody } from 'models/certifyingBody';

interface Props {
  open: boolean;
  loading: boolean;
  certifyingBody: ICertifyingBody;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const EditCertifyingBody: React.FC<Props> = ({ open, loading, certifyingBody, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation();

  let basicFields: IFormField[] = [
    {
      name: 'name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      defaultValue: certifyingBody.name,
      internalLabel: true,
      required: true
    },
    {
      name: 'Logo',
      label: t('T_Logo'),
      type: InputTypes.FILE,
      internalLabel: true,
      defaultImageUrl: certifyingBody.logo,
      required: false
    },
    {
      name: 'isActive',
      label: t('T_active'),
      type: InputTypes.CHECKBOX,
      defaultValue: certifyingBody.isActive,
      internalLabel: true,
      required: false
    },
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_certifying_body')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2}>
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1}>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_edit')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>
        </Grid>
      }
    />
  );
};

export default EditCertifyingBody;

